import { computed, inject } from 'vue'

// The store grid lays cards out as half-width tiles that wrap. Every card root carried its own copy
// of this string before the upsell modal needed other layouts.
export const GRID_TILE_CLASSES = 'w-screen max-w-xl px-2 sm:w-1/2 sm:px-2 mb-4 md:mb-8'

// One product per full-width row. The modal panel already owns the horizontal padding, so a row
// spends the whole width and only needs separating from the row below it.
export const UPSELL_ROW_CLASSES = 'w-full mb-3'

// Mark's 2x2 - but only from `sm` up. The sheet is full-bleed on a phone, where two columns leave a
// tile around 175px: narrower than the desktop case that already wrapped product titles onto three
// lines and squeezed the variant dropdowns, so below `sm` the tiles stack instead.
// Deliberately not GRID_TILE_CLASSES: that one is `w-screen`-based for the store's full-bleed grid
// and would overflow the modal panel.
export const UPSELL_TILE_CLASSES = 'w-full sm:w-1/2 px-1 mb-2'

// `inUpsellModal` / `upsellModalLayout` are provided by UpsellModal, mirroring the `inQuestionModal`
// inject BOT-1342 uses to restyle the same cards inside the question modal.
export function useProductCardLayout() {
  const inUpsellModal = inject('inUpsellModal', false)
  const upsellModalLayout = inject('upsellModalLayout', 'list')

  return {
    inUpsellModal,
    cardLayoutClasses: computed(() => {
      if (!inUpsellModal) return GRID_TILE_CLASSES
      return upsellModalLayout === 'grid' ? UPSELL_TILE_CLASSES : UPSELL_ROW_CLASSES
    })
  }
}
